<app-content-module id="specHeader">
  <div class="spec-container">
    <h5>Product specifications</h5>

    <ng-container *ngIf="keyFeatures?.length">
      <div
        class="key-features"
        [ngClass]="'key-features__count--' + numberOfFeatures"
      >
        <ng-container *ngFor="let f of keyFeatures">
          <div class="feature" *ngIf="f.value">
            <p class="feature__value">
              <small>{{ f.value }}</small>
            </p>
            <p class="feature__name">
              <small
                ><strong>{{ f.name }}</strong></small
              >
            </p>
          </div>
        </ng-container>
      </div>
    </ng-container>

    <app-table
      [visibleRows]="visibleRows"
      [specifications]="[specifications]"
    ></app-table>
  </div>
</app-content-module>
<app-accordion
  *ngIf="defaultRows < specifications.length"
  (toggled)="toggleClick($event)"
  [isOpen]="isOpen"
>
  <ng-container header>{{
    isOpen ? 'Show less specifications' : 'Show full specifications'
  }}</ng-container>
</app-accordion>
